module.exports = __webpack_public_path__ + "img/ICON_AR.de366e4a.png";